export const GET_UOMS = 'GET_UOMS';
export const CREATE_UOM  = 'CREATE_UOM';
export const GET_UOMS_STRUCTURE  = 'GET_UOMS_STRUCTURE';
export const UOM_REQUEST  = 'UOM_REQUEST';
export const DELETE_UOM  = 'DELETE_UOM';
export const UPDATE_UOM  = 'UPDATE_UOM';
export const UOM_REQUEST_FAILURE  = 'UOM_REQUEST_FAILURE';